import { render } from "./Programms.vue?vue&type=template&id=41ad491c"
import script from "./Programms.vue?vue&type=script&lang=js"
export * from "./Programms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__